import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Field, Form, Formik } from "formik";
import qs from "query-string";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import Button from "@material-ui/core/Button";

import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import usePlans from "../../hooks/usePlans";
import { i18n } from "../../translate/i18n";

import { InputLabel, MenuItem, Select } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import toastError from "../../errors/toastError";
import { openApi } from "../../services/api";
import { countryRules } from "../../utils/countryRules";

const useStyles = makeStyles((theme) => ({
  root: {
    //marginTop: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    overflowY: "auto",
    background: theme.mode === "light" ? theme.palette.light : theme.palette.dark,
  },
  rightScreen: {
    flex: 1,
    width: "100vw",
    height: "100vh",
    background:
      theme.mode === "light" ? theme.palette.light : theme.palette.dark,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  paper: {
    backgroundColor:
      theme.mode === "light"
        ? "rgba(255, 255, 255, 0.8)"
        : "rgba(0, 0, 0, 0.8)",
    backdropFilter: "blur(5px)",
    boxShadow:
      theme.mode === "light"
        ? "0 4px 6px rgba(0, 0, 0, 0.2)"
        : "0 4px 6px rgba(0, 0, 0, 0.5)",
    maxHeight: "90vh",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "25px",
    borderRadius: "12px",
    maxWidth: "400px",
    width: "100%",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  logoImg: {
    width: "100%",
    maxWidth: "250px",
    height: "auto",
    maxHeight: "120px",
    margin: "0 auto",
    content:
      "url(" +
      (theme.mode === "light"
        ? theme.calculatedLogoLight()
        : theme.calculatedLogoDark()) +
      ")",
  },
  link: {
    fontSize: "16px",
    lineHeight: "24px",
    color: theme.mode === "light" ? "black" : "white",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: "#f7f7f7",
    borderRadius: "50px",
  },
  span: {
    color: theme.mode === "light" ? "green" : "white",
  },
  spanRed: {
    color: "red",
  },
  iconPassword: {
    color: theme.mode === "light" ? "inherit" : "#f1f1f1",
  },
}));

const getPhoneValidationSchema = (maxLength, countryCode) => {
  return Yup.string()
    .required("Phone é obrigatório")
    .matches(
      new RegExp(`^\\d{${maxLength}}$`),
      `Digite o número completo no formato (${countryCode}) e com ${maxLength} dígitos (apenas números).`
    );
};

const UserSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Nome é obrigatório"),
  companyName: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Nome da empresa é obrigatória"),
  password: Yup.string()
    .min(8, "")
    .matches(/[a-z]/, " ")
    .matches(/[A-Z]/, " ")
    .required("Senha é obrigatória"),
  email: Yup.string().email("E-mail inválido").required("E-mail é obrigatório"),
  // phone: Yup.string()
  //   .required("Phone é obrigatório")
  //   .matches(
  //     /^\d{13}$/,
  //     "Digite o número completo no formato (XX) 9 XXXX-XXXX (apenas números)."
  //   ),

  termo: Yup.boolean()
    .oneOf([true], "Você deve aceitar os termos para continuar.")
    .required("A aceitação dos termos é obrigatória"),
});

const SignUp = () => {
  const classes = useStyles();
  const history = useHistory();
  const { getPlanList } = usePlans();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [phoneValidationSchema, setPhoneValidationSchema] = useState(
    getPhoneValidationSchema(13, "BR")
  );
  let companyId = null;
  const params = qs.parse(window.location.search);
  if (params.companyId !== undefined) {
    companyId = params.companyId;
  }

  const calculateProgress = (password) => {
    let progress = 0;
    if (password.length >= 8) progress += 33;
    if (/[a-z]/.test(password)) progress += 33;
    if (/[A-Z]/.test(password)) progress += 34;
    return progress;
  };

  const initialState = {
    name: "",
    email: "",
    password: "",
    phone: "",
    companyId,
    companyName: "",
    planId: "",
    termo: false,
  };

  const [user] = useState(initialState);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const planList = await getPlanList({listPublic: false});

      setPlans(planList);
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCountryChange = (countryCode) => {
    const rules = countryRules[countryCode.toLowerCase()] || {
      maxLength: 11,
      code: countryCode.toUpperCase(),
    };

    setPhoneValidationSchema(
      getPhoneValidationSchema(rules.maxLength, rules.code)
    );
  };

  const handleSignUp = async (values) => {
    console.log(values);

    try {
      await openApi.post("/auth/signup", values);
      toast.success(i18n.t("signup.toasts.success"));
      history.push("/login");
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <div className={classes.leftScreen}>
      </div>
      <div className={classes.paper}>
        <div>
          <img className={classes.logoImg} alt="logo" />
        </div>
        <Typography component="h1" variant="h5">
          {i18n.t("signup.title")}
        </Typography>
        {/* <form className={classes.form} noValidate onSubmit={handleSignUp}> */}
        <Formik
          initialValues={user}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            ...UserSchema.fields,
            phone: phoneValidationSchema, // Inclui o esquema dinâmico de telefone
          })}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSignUp(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <Form className={classes.form}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    autoComplete="name"
                    name="name"
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    variant="outlined"
                    size="small"
                    fullWidth
                    id="name"
                    label={i18n.t("signup.form.name")}
                    // autoFocus
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    variant="outlined"
                    fullWidth
                    size="small"
                    id="companyName"
                    label={i18n.t("signup.form.company")}
                    error={touched.companyName && Boolean(errors.companyName)}
                    helperText={touched.companyName && errors.companyName}
                    name="companyName"
                    autoComplete="companyName"
                    autoFocus
                  />
                </Grid>

                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    variant="outlined"
                    fullWidth
                    id="email"
                    size="small"
                    label={i18n.t("signup.form.email")}
                    name="email"
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    autoComplete="email"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    variant="outlined"
                    fullWidth
                    name="password"
                    size="small"
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                    label={i18n.t("signup.form.password")}
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleTogglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? (
                              <VisibilityOff className={classes.iconPassword} />
                            ) : (
                              <Visibility className={classes.iconPassword} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{
                      width: "100%",

                      marginTop: "10px",
                    }}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={calculateProgress(values.password)}
                      color="primary"
                    />
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        alignItems: "center",
                        marginTop: "5px",
                      }}
                    >
                      <span
                        className={
                          values.password.length >= 8
                            ? classes.span
                            : classes.spanRed
                        }
                      >
                        8+ caracteres
                      </span>
                      <span
                        className={
                          /[a-z]/.test(values.password)
                            ? classes.span
                            : classes.spanRed
                        }
                      >
                        Minúscula
                      </span>
                      <span
                        className={
                          /[A-Z]/.test(values.password)
                            ? classes.span
                            : classes.spanRed
                        }
                      >
                        Maiúscula
                      </span>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="phone"
                    render={({ field }) => (
                      <PhoneInput
                        country={"br"}
                        value={values.wpp}
                        required
                        onChange={(value, country) => {
                          setFieldValue("phone", value);
                          handleCountryChange(country.countryCode);
                        }}
                        inputStyle={{
                          height: 40,
                          width: "100%",
                        }}
                        containerStyle={{
                          height: 40,
                        }}
                      />
                    )}
                  />
                  {errors.phone && touched.phone ? (
                    <div style={{ color: "red" }}>{errors.phone}</div>
                  ) : null}
                </Grid>

                {/* TOKEN */}
                {/* <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        variant="outlined"
                                        fullWidth
                                        id="token"
                                        label={i18n.t("auth.token")}
                                        name="token"
                                        autoComplete="token"
                                    />
                                </Grid> */}

                <Grid item xs={12}>
                  <InputLabel htmlFor="plan-selection">Plano</InputLabel>
                  <Field
                    as={Select}
                    variant="outlined"
                    fullWidth
                    id="plan-selection"
                    label="Plano"
                    name="planId"
                    required
                    style={{
                      height: 40,
                    }}
                  >
                    {plans.map((plan, key) => (
                      <MenuItem key={key} value={plan.id}>
                        {plan.name} - Atendentes: {plan.users} - WhatsApp:{" "}
                        {plan.connections} - Filas: {plan.queues} - R${" "}
                        {plan.amount}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={values.termo}
                        onChange={(event) => {
                          setFieldValue("termo", event.target.checked);
                        }}
                        color="primary"
                        name="termo"
                      />
                    }
                    style={{ alignItems: "flex-center", marginRight: "5px" }}
                    label={
                      <span
                        style={{
                          textAlign: "justify",
                          fontSize: "14px",
                          paddingTop: "5px",
                        }}
                      >
                        Li e aceito os termos de uso.
                      </span>
                    }
                  />
                  {errors.termo && touched.termo ? (
                    <div style={{ color: "red" }}>{errors.termo}</div>
                  ) : null}
                </Grid>
              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={isSubmitting}
              >
                {i18n.t("signup.buttons.submit")}
              </Button>
              <div style={{ textAlign: "end" }}>
                <Grid item>
                  <Link
                    className={classes.link}
                    href="#"
                    variant="body2"
                    component={RouterLink}
                    to="/login"
                  >
                    {i18n.t("signup.buttons.login")}
                  </Link>
                </Grid>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {/* <Box mt={5}><Copyright /></Box> */}
    </div>
  );
};

export default SignUp;